import toast from "react-hot-toast";
import { put, takeLatest, all, call } from "redux-saga/effects";

import {
    setPartPaymentLoader,
    setPartPaymentList
} from "../actionCreators/partPaymentActionCreators";
import {
    GET_PART_PAYMENT_LIST,
    UPLOAD_PART_PAYMENT_FILE
} from "../actionTypes/partPaymentActionType";
import {
    getPartPaymentService, uploadPartPaymentFileService,
} from "../services/partPaymentService";

function* _getPartPaymentList(_data: any) {
    try {
        yield put(setPartPaymentLoader(true));
        const { data } = yield call(getPartPaymentService, _data.payload);
        yield put(setPartPaymentLoader(false));
        if (data.status == true) {
            yield put(setPartPaymentList(data.data || {}))
        }
        else {
            _data.callback && _data.callback(data)
        }
    }
    catch (err: any) {
        yield put(setPartPaymentLoader(false));
        console.log("_getPartPaymentList: exceptionError: ", err)
        toast.error("Something went wrong.")
    }
}

function* _uploadPartPaymentFile(_data: any) {
    try {
        yield put(setPartPaymentLoader(true));
        const { data } = yield call(uploadPartPaymentFileService, _data.payload);
        yield put(setPartPaymentLoader(false));
        if (data.status == true) {
            _data.callback && _data.callback(data)
        }
        else {
            toast.error(data.statusDescription || "Failed to upload file.")
        }
    }
    catch (err: any) {
        yield put(setPartPaymentLoader(false));
        console.log("_uploadPartPaymentFile: exceptionError: ", err)
        toast.error("Something went wrong.")
    }
}

export default function* partPaymentSaga() {
    yield all([
        takeLatest(GET_PART_PAYMENT_LIST, _getPartPaymentList),
        takeLatest(UPLOAD_PART_PAYMENT_FILE, _uploadPartPaymentFile),
    ])
}
